import { Form, Input } from 'antd';
import EyeIcon from 'assets/icons/eye.svg';
//eyeSlash
import EyeSlashIcon from 'assets/icons/eye-slash.svg';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { Rule } from 'antd/es/form';

interface props {
    label: string;
    name: string;
    errorMessage?: string;
    isDisplayNote?: boolean;
}

export const PasswordFormItem = ({ label, name, errorMessage, isDisplayNote = false }: props) => {

    const rules: Rule[] = [
        {
            required: true,
            message: getMessage('In_Required', 'パスワード'),
        },
        {
            pattern: /^(?=.*?[a-z\d])(?=.*?[A-Z])[!-~]{8,}$/,
            message: getMessage('Pass_Invalid_2'),
        },
    ];

    const validateMatch = ({ getFieldValue } : any) => ({
        validator(_ : any, value : string) {
          if (!value || getFieldValue('oldPassword') != value) {
            return Promise.resolve();
          }
          return Promise.reject(new Error('現在のパスワードと変更後のパスワードが同一です。再設定してください。'));
        },
      });

    if(name == 'newPassword') {
        rules.push(validateMatch);
    }


    return (
        <section style={{ width: '100%', marginTop: 16 }}>
            <div style={{ marginBottom: isDisplayNote ? 6 : 16, fontSize: 16 }} className="label">
                {label}
            </div>
            {isDisplayNote && (
                <div style={{ marginBottom: 10, fontSize: 10 }}>大文字小文字を含む半角英数字(8桁以上)</div>
            )}
            <Form.Item
                required={false}
                className=" label-form-style mb-1"
                name={name}
                label={false}
                rules={rules}
            >
                <Input.Password
                    iconRender={(visible) =>
                        visible ? (
                            <img className="button-style" alt="" src={EyeIcon} />
                        ) : (
                            <img className="button-style" alt="" src={EyeSlashIcon} />
                        )
                    }
                    size="large"
                    style={{ width: '100%' }}
                    minLength={8}
                    placeholder={PLACEHOLDER.PASSWORD}
                />
            </Form.Item>
            {errorMessage && <p style={{ textAlign: 'left', color: 'red', marginTop: '0px', marginBottom: '0px' }}>{errorMessage}</p>}
        </section>
    );
};
